// /app/open#code=…&to=… — the iOS app opens a web page as its own account
// (TOM-909, cloud ADR 0441; contract §2.9). The app's web sheet keeps its own
// cookies, so the app asks the cloud for a one-time code and opens this page
// with it. The page trades the code for a session and goes on to `to`.

/** What the fragment carries: a code and the page to open, or nothing usable. */
export type WebHandoffRequest = { code: string; to: string } | null;

/**
 * Read the fragment. `to` must be a path under /dashboard; the server checks it
 * again, and this check only keeps the page from going anywhere else.
 */
export function webHandoffRequest(hash: string): WebHandoffRequest {
  const params = new URLSearchParams(hash.replace(/^#/, ''));
  const code = params.get('code') ?? '';
  const to = params.get('to') ?? '';
  if (code.length === 0 || !isDashboardPath(to)) return null;
  return { code, to };
}

function isDashboardPath(to: string): boolean {
  if (to !== '/dashboard' && !to.startsWith('/dashboard/') && !to.startsWith('/dashboard?')) {
    return false;
  }
  // No protocol-relative tricks: /dashboard is a fixed prefix, so only control
  // characters, whitespace and backslashes are left to refuse.
  for (let i = 0; i < to.length; i++) {
    const c = to.charCodeAt(i);
    if (c <= 0x20 || c === 0x7f || to[i] === '\\') return false;
  }
  return true;
}
